import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
let csrfRequest = null;
let csrfToken = null;

const rememberCsrf = (response) => {
  const token = response?.headers?.["x-csrf-token"] || response?.data?.csrf_token;
  if (token) csrfToken = token;
  return response;
};

const ensureCsrf = async () => {
  if (csrfToken) return csrfToken;
  csrfRequest = csrfRequest || axios.get(`${API}/auth/csrf`, { withCredentials: true }).then(rememberCsrf);
  try {
    const response = await csrfRequest;
    return response.data.csrf_token;
  } finally {
    csrfRequest = null;
  }
};

api.interceptors.request.use(async (config) => {
  const method = (config.method || "get").toLowerCase();
  const exempt = ["/auth/login", "/auth/forgot-password", "/auth/set-password"];
  if (["post", "put", "patch", "delete"].includes(method) && !exempt.some((path) => config.url?.includes(path))) {
    config.headers.set("X-CSRF-Token", await ensureCsrf());
  }
  return config;
});

api.interceptors.response.use(
  rememberCsrf,
  async (error) => {
    const original = error.config;
    const noRefresh = ["/auth/login", "/auth/refresh", "/auth/forgot-password", "/auth/set-password"];
    if (error.response?.status === 401 && original && !original._retry && !noRefresh.some((path) => original.url?.includes(path))) {
      original._retry = true;
      try {
        refreshing = refreshing || ensureCsrf().then((token) => axios.post(
          `${API}/auth/refresh`, {}, { withCredentials: true, headers: { "X-CSRF-Token": token } }
        )).then(rememberCsrf);
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
